import _slicedToArray from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { jsxs as e, jsx as t } from "react/jsx-runtime";
import { Fonts as n } from "@vds-core/typography";
import { calculateRem as i, withVDSManager as o, generateUUID as r } from "@vds-core/utilities";
import { ColorTokens as a } from "@vds-tokens/color";
import { LayoutTokens as l } from "@vds-tokens/layout";
import { TypographyTokens as c } from "@vds-tokens/typography";
import { useRef as s, useState as d, useEffect as u } from "react";
import p from "styled-components";
import f from "./ToggleSwitch.js";
function g(e, t) {
  return e ? a.elements.secondary["on".concat(t)].value : a.elements.primary["on".concat(t)].value;
}
function h(e) {
  return e && e ? "On" : "Off";
}
var m = p.div.withConfig({
    displayName: "Container",
    componentId: "VDS__sc-fhbxpp-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"]))),
  x = p.span.withConfig({
    displayName: "ScreenReaderText",
    componentId: "VDS__sc-fhbxpp-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n"]))),
  y = p.div.withConfig({
    displayName: "ToggleWrapper",
    componentId: "VDS__sc-fhbxpp-2"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  display: inline-block;\n  position: relative;\n  height: ", ";\n  outline: 0;\n"])), i(16), function (_ref) {
    var e = _ref.$toggleHeight;
    return i(e);
  }),
  v = p.div.withConfig({
    displayName: "TextWrapper",
    componentId: "VDS__sc-fhbxpp-3"
  })(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n  font-weight: ", ";\n  ", "\n"])), function (_ref2) {
    var e = _ref2.$textSize;
    return "large" === e ? "\n          font-size: ".concat(i(c.fontsize.body[16].value), ";\n          line-height: ").concat(i(c.lineheight.body[20].value), ";\n          font-family: ").concat(n.VerizonNHGeDS, ";\n          letter-spacing: ").concat(c.letterspacing.wide.value, ";\n        ") : "\n          font-size: ".concat(i(c.fontsize.body[12].value), ";\n          line-height: ").concat(i(c.lineheight.body[16].value), ";\n          font-family: ").concat(n.VerizonNHGeTX, ";\n        ");
  }, function (_ref3) {
    var e = _ref3.$textWeight;
    return "bold" === e ? c.fontweight.bold.value : c.fontweight.regular.value;
  }, function (_ref4) {
    var e = _ref4.$textPosition;
    return "right" === e ? "padding-left: ".concat(i(l.space["3X"].value), "; padding-right: 0;\n          text-align: left;\n        ") : "padding-right: ".concat(i(l.space["3X"].value), "; padding-left: 0;\n        text-align: right;");
  }),
  b = p.span.withConfig({
    displayName: "HitArea",
    componentId: "VDS__sc-fhbxpp-4"
  })(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  top: 50%;\n  cursor: pointer;\n  display: inline-block;\n  height: ", ";\n  width: 100%;\n"])), i(44));
var $ = o(function (n) {
  var _n$disabled = n.disabled,
    i = _n$disabled === void 0 ? !1 : _n$disabled,
    o = n.value,
    a = n.name,
    _n$showText = n.showText,
    l = _n$showText === void 0 ? !1 : _n$showText,
    c = n.id,
    p = n.inputId,
    $ = n.tabIndex,
    k = n["data-analyticstrack"],
    w = n["data-track"],
    T = n["data-track-ignore"],
    S = n["data-clickstream"],
    _n$textPosition = n.textPosition,
    C = _n$textPosition === void 0 ? "left" : _n$textPosition,
    _n$textWeight = n.textWeight,
    z = _n$textWeight === void 0 ? "regular" : _n$textWeight,
    _n$textSize = n.textSize,
    I = _n$textSize === void 0 ? "small" : _n$textSize,
    _n$surface = n.surface,
    D = _n$surface === void 0 ? "light" : _n$surface,
    _n$surfaceType = n.surfaceType,
    _ = _n$surfaceType === void 0 ? "colorFill" : _n$surfaceType,
    _n$statusText = n.statusText,
    P = _n$statusText === void 0 ? h : _n$statusText,
    H = n.ariaLabel,
    _n$toggleHeight = n.toggleHeight,
    N = _n$toggleHeight === void 0 ? 28 : _n$toggleHeight,
    _n$knobSize = n.knobSize,
    V = _n$knobSize === void 0 ? 24 : _n$knobSize,
    _n$knobLeftPosition = n.knobLeftPosition,
    L = _n$knobLeftPosition === void 0 ? 24 : _n$knobLeftPosition,
    W = n.on,
    _n$onChange = n.onChange,
    K = _n$onChange === void 0 ? function () {} : _n$onChange,
    O = void 0 !== W,
    X = s(p || r()),
    j = s(r()),
    _d = d(W || !1),
    _d2 = _slicedToArray(_d, 2),
    A = _d2[0],
    G = _d2[1],
    _d3 = d(!1),
    _d4 = _slicedToArray(_d3, 2),
    M = _d4[0],
    E = _d4[1],
    _d5 = d(!1),
    _d6 = _slicedToArray(_d5, 2),
    F = _d6[0],
    R = _d6[1],
    q = s(null);
  u(function () {
    W !== A && G(O ? W : A), q.current && clearTimeout(q.current), q.current = setTimeout(function () {
      R(!1);
    });
  }, [W, A]);
  var B = function B(e) {
      e.stopPropagation(), i || ("click" === e.type && M && "undefined" != typeof document && document.activeElement.blur(), R(!0), K && K(e, {
        name: a,
        value: o,
        on: !A,
        index: n.index
      }), O || G(!A));
    },
    J = function J() {
      return t(v, {
        $textPosition: C,
        $calculateTextColor: g,
        $textWeight: z,
        $textSize: I,
        $showText: l,
        style: {
          color: null == g ? void 0 : g(null != i && i, null != D ? D : "light")
        },
        children: P(null == A || A)
      });
    };
  return e(m, {
    children: ["left" === C && l && J(), e(y, {
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      id: c,
      onMouseOver: function onMouseOver() {
        return E(!0);
      },
      onMouseLeave: function onMouseLeave() {
        return E(!1);
      },
      onKeyDown: function onKeyDown(e) {
        var t = 32 === e.keyCode,
          i = 13 === e.keyCode;
        t && e.preventDefault(), (i || t) && "click" !== e.type && (B(e), n.onKeyDown && n.onKeyDown(e));
      },
      $toggleHeight: N,
      children: [t(b, {
        "data-testid": "test-hitArea",
        "aria-hidden": !0,
        onClick: i ? void 0 : function (e) {
          return B(e);
        }
      }), t(x, {
        "aria-live": "assertive",
        children: F && H
      }), t(f, {
        "data-testid": "test-toggle",
        name: a,
        value: o,
        on: A,
        disabled: i,
        tabIndex: i ? -1 : $ || 0,
        calculateTextColor: g,
        analyticsTrack: k,
        track: w,
        trackIgnore: T,
        clickStream: S,
        showText: l,
        surface: D,
        surfaceType: _,
        inputId: X.current,
        focusId: j.current,
        handleSwitchClick: B,
        textPosition: C,
        ariaLabel: H,
        toggleHeight: N,
        knobSize: V,
        knobLeftPosition: L
      })]
    }), "right" === C && l && J()]
  });
});
export { $ as default };